module.exports = __webpack_public_path__ + "static/media/booklet.20ce9195.svg";